export const employeeSidebarData = [
    {
        itemName: 'ダッシュボード',
        itemUrl: '/user-dashboard',
        subItems: []
    },
    {
        itemName: 'プロファイル',
        itemUrl: '/profile',
        subItems: []
    },
    {
        itemName: '技術一覧',
        itemUrl: '/my-technologies',
        subItems: []
    },
    {
        itemName: 'プロジェクト',
        itemUrl: '/my-projects',
        subItems: []
    },
];
